import { combineReducers } from 'redux';
import Config from 'conf';
import { Map } from 'immutable';
import Logger from 'data/common/Logger';
import genericEnv from 'environments/genericEnv';

import myfhe from './myfhe';
import testbench from './testbench';
import logging from './logging';
import simulationenr from './simulationenr';
import ticketsgit from './ticketsgit';
import fhe from './fhe';
import fhepool from './fhepool';

let allEnv = {};

Config.environments.map(env => {
    switch (env) {
        case 'myfhe':
            allEnv['myfhe'] = myfhe;
            break;
        case 'testbench':
            allEnv['testbench'] = testbench;
            break;
        case 'logging':
            allEnv['logging'] = logging;
            break;
        case 'simulationenr':
            allEnv['simulationenr'] = simulationenr;
            break;
        case 'ticketsgit':
            allEnv['ticketsgit'] = ticketsgit;
            break;
        case 'fhe':
            allEnv['fhe'] = fhe;
            break;
        case 'fhepool':
            allEnv['fhepool'] = fhepool;
            break;
        case 'cocoon':
            allEnv['cocoon'] = genericEnv;
            break;
        case 'fheconnect':
            allEnv['fheconnect'] = genericEnv;
            break;
        case 'homing':
            allEnv['homing'] = genericEnv;
            break;
        case 'lacin':
            allEnv['lacin'] = genericEnv;
            break;
        case 'domalisa':
            allEnv['domalisa'] = genericEnv;
            break;
        case 'accesshabitat':
            allEnv['accesshabitat'] = genericEnv;
            break;
        case 'maestro':
            allEnv['maestro'] = genericEnv;
            break;
        case 'weezeo':
            allEnv['weezeo'] = genericEnv;
            break;
        case 'niceenergie':
            allEnv['niceenergie'] = genericEnv;
            break;
        case 'mghabitat':
            allEnv['mghabitat'] = genericEnv;
            break;
        case 'idealys':
            allEnv['idealys'] = genericEnv;
            break;
        case 'inogreen':
            allEnv['inogreen'] = genericEnv;
            break;
        default:
            Logger.error(`L'environnement "${env}" du fichier de config n'est pas codé ou n'est pas importé dans le fichier environnements/index.js`);
    }
});

let allRoutes = new Map();
let allReducers = {};
let envWithEntry = new Map();
Object.keys(allEnv).map((env, index) => {
    let routesFile = allEnv[env].getRoutes(env);
    let allPath = [];
    routesFile.map((route, path) => {
        route.environment = env;
        route.path = `/${route.environment}${path}`;
        route.index = route.index ? route.index : route.children ? 2 : 1;

        allRoutes = allRoutes.setIn([route.path], route);
        if (route.firstPage) envWithEntry = envWithEntry.setIn([env], { index, path: route.path });
        else allPath.push({ path: route.path, right: route.right });
        if (route.children) {
            route.children.map((subRoute, subPath) => {
                subRoute.environment = env;
                subRoute.path = `${route.path}${subPath}`;
                subRoute.modal = true;
                subRoute.index = subRoute.index ? subRoute.index : 3;
                allRoutes = allRoutes.setIn([subRoute.path], subRoute);
            });
        }
    });
    allReducers[env] = allEnv[env].getReducers(env);
    if (!envWithEntry.has(env)) {
        // envWithEntry = envWithEntry.setIn([env], `${routesFile.first().path}`);
        envWithEntry = envWithEntry.setIn([env], { index, path: allPath });
    }
});

export default {
    getRoutes: function() {
        return allRoutes;
    },
    getReducers: function() {
        return combineReducers(allReducers);
    },
    getEnvironments: function() {
        return envWithEntry;
    }
};



// WEBPACK FOOTER //
// ./environments/index.js